/**
 * Locale needs to be omitted from the path for multilingual sites
 * For non-multilingual sites, make sure locale is not passed
 */ function createPath(path, locale) {
    // The Bloomreach `initialize` method returns a 404 error if a quote is sent in the path
    const cleanPath = path.replace(/'/g, '%27');
    if (locale === undefined) {
        return cleanPath;
    }
    const localePath = `/${locale.replace('-', '_')}`;
    // If the path is exactly equal to the localePath (e.g. home page request)
    // We need to return a / so we don't return an empty string
    if (cleanPath === localePath) {
        return '/';
    }
    return cleanPath.includes(localePath) ? cleanPath.replace(localePath, '') : cleanPath;
}

export { createPath };
//# sourceMappingURL=create-path.js.map
